import { Bell, CheckCircle2, Package, Briefcase, FileText, Mail } from "lucide-react";
import { Badge } from "./ui/badge";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import { Button } from "./ui/button";

const TYPE_ICON = {
  order: Package,
  corporate: Briefcase,
  service: Briefcase,
  inquiry: FileText,
  system: Bell,
};

const NotificationsBell = ({ notifications, unreadCount, onMarkAllRead, onOpenAll, onMarkRead }) => {
  const recent = notifications.slice(0, 6);
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className="relative p-2 rounded-md hover:bg-slate-100 transition-colors"
          aria-label="Notifications"
          data-testid="notifications-bell"
        >
          <Bell className="h-5 w-5 text-slate-600" />
          {unreadCount > 0 && (
            <span className="absolute -top-0.5 -right-0.5 inline-flex items-center justify-center w-4 h-4 text-[10px] font-semibold rounded-full bg-orange-500 text-white">
              {unreadCount > 9 ? "9+" : unreadCount}
            </span>
          )}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-96 p-0" data-testid="notifications-dropdown">
        <div className="flex items-center justify-between px-4 py-3 border-b">
          <div>
            <p className="font-medium text-sm">Notifications</p>
            <p className="text-xs text-slate-500">{unreadCount} unread</p>
          </div>
          {unreadCount > 0 && (
            <Button variant="ghost" size="sm" onClick={onMarkAllRead} className="h-7 text-xs" data-testid="mark-all-read-btn">
              <CheckCircle2 className="h-3 w-3 mr-1" /> Mark all read
            </Button>
          )}
        </div>
        <div className="max-h-96 overflow-y-auto">
          {recent.length === 0 ? (
            <div className="px-4 py-12 text-center">
              <Mail className="h-8 w-8 text-slate-300 mx-auto mb-2" />
              <p className="text-sm text-slate-500">You're all caught up</p>
            </div>
          ) : recent.map((n) => {
            const Icon = TYPE_ICON[n.type] || Bell;
            return (
              <button
                key={n.id}
                type="button"
                onClick={() => { onMarkRead?.(n.id); onOpenAll?.(); }}
                className={`w-full flex items-start gap-3 px-4 py-3 text-left border-b last:border-b-0 hover:bg-slate-50 transition-colors ${
                  !n.is_read ? "bg-blue-50/50" : ""
                }`}
                data-testid={`notif-item-${n.id}`}
              >
                <div className={`p-1.5 rounded bg-slate-100 ${!n.is_read ? "text-brand" : "text-slate-500"}`}>
                  <Icon className="h-4 w-4" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="font-medium text-sm truncate">{n.title}</p>
                  <p className="text-xs text-slate-500 line-clamp-2 mt-0.5">{n.message}</p>
                  <p className="text-[10px] text-slate-400 mt-1">{new Date(n.created_at).toLocaleString()}</p>
                </div>
                {!n.is_read && <span className="w-2 h-2 rounded-full bg-brand mt-2 flex-shrink-0" />}
              </button>
            );
          })}
        </div>
        {notifications.length > 0 && (
          <div className="border-t">
            <Button variant="ghost" onClick={onOpenAll} className="w-full h-10 rounded-none text-sm" data-testid="view-all-notifications-btn">
              View all notifications
            </Button>
          </div>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default NotificationsBell;
